import React from 'react';
import './PaymentSettings.css';

const PaymentSettings = () => {
  return (
    <div className="content-box animated">
      <h3>Payment Settings</h3>
      <p>Configure your payment methods and account details here.</p>
      <form className="payment-settings-form">
        <label>
          Payment Gateway:
          <select>
            <option value="vpay">V PAY</option>
            <option value="gpay">GPAY</option>
            <option value="netbanking">Net Banking</option>
          </select>
        </label>
        <label>
          Account Email:
          <input type="email" placeholder="your-email@example.com" />
        </label>
        <button type="submit" className="save-settings-btn">Send E-Mail</button>
      </form>
    </div>
  );
};

export default PaymentSettings;
